/**
 * 班级卡片
 */
export default {
  groupBuy: '단체 구매',
}
